import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { IBaseItem } from "../types";
import { FitTypeServices } from "../../../services";

const ColumnSelectFitType = (
    {
        placeholder
        , value
        , onChange
    }: any) => {

    const [options, setOptions] = useState<any[]>();


    const onSelectChange = (e: any) => {

        if (onChange) onChange(e.value);
    }

    useEffect(() => {
        (async () => {
            const getResponse = await FitTypeServices.GetFitTypes();

            const optionsResponse = getResponse.map((element: IBaseItem) => {
                return {
                    value: element.Id.toString(),
                    name: element.Name
                };
            });

            setOptions(optionsResponse);
        })();

    }, []);

    return (
        <div className="card flex justify-content-center">
            <Dropdown
                value={((options &&  options.length) ? value : null)}
                onChange={(e) => onSelectChange(e)}
                options={options}
                optionLabel="name"
                placeholder={placeholder}
                className="w-full md:w-14rem"
                style={{ minWidth: "100%" }}
            />
        </div>
    );
};

export default ColumnSelectFitType;
